import { render, staticRenderFns } from "./MCapOrderView.vue?vue&type=template&id=509a3eca&scoped=true&"
import script from "./MCapOrderView.vue?vue&type=script&lang=js&"
export * from "./MCapOrderView.vue?vue&type=script&lang=js&"
import style0 from "./MCapOrderView.vue?vue&type=style&index=0&id=509a3eca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509a3eca",
  null
  
)

export default component.exports